"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTableService = void 0;
const __1 = require("..");
const domain_1 = require("../../../domain");
const mappers_1 = require("../mappers");
class FTableService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    checkTablesAvailability(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const checkTablesAvailabilityMapper = new mappers_1.CheckTablesAvailabilityMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.CHECK_TABLES_AVAILABILITY,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve(checkTablesAvailabilityMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.TableServiceErrors.CheckTablesAvailabilityRequestError("CHECK_TABLES_AVAILABILITY_REQUEST_FAILED", error));
            }
        });
    }
}
exports.FTableService = FTableService;
